import * as Sentry from '@sentry/react';
import { logger } from './LoggerService';

/**
 * Creates a traces sampler that returns 100% for debug mode users.
 * Called per transaction, so it can check current debug state.
 *
 * @param defaultRate - The default sampling rate when debug mode is off (0-1)
 * @returns A sampler function for use with Sentry's tracesSampler option
 */
export function createDebugAwareTracesSampler(defaultRate = 0.3) {
  return (): number => {
    if (logger.isDebugMode()) {
      return 1.0; // 100% sampling for debug users
    }
    return defaultRate;
  };
}

/**
 * Start Sentry replay recording for debug mode.
 * Should be called when debug mode activates.
 */
export function startReplayForDebugMode(): void {
  const replay = Sentry.getReplay();
  if (replay) {
    replay.start();
  }
}

/**
 * Stop Sentry replay recording when debug mode ends.
 * Should be called when debug mode expires or is disabled.
 */
export function stopReplayForDebugMode(): void {
  const replay = Sentry.getReplay();
  if (replay) {
    replay.stop();
  }
}
